import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AdapterOptions } from '../../../../../adapters/types'
import { DischargeFormData } from '../../../../types/formData'
import { DischargeFormField } from '../../../../types/formField'
import { DischargeAssessmentQuestionnaireItem } from '../../../../types/questionnaire'
import { getAnswerValuesFromItems } from '../../../../../helpers'
import { BaseSubsectionAdapter } from '../../../../../adapters/BaseSubsectionAdapter'
import { FlatAnswerMutation } from '../../../../../adapters/types'

/**
 * Musculoskeletal subsection adapter
 * Handles musculoskeletal system assessment (2 fields - simplest after Lines/Drains)
 */
export class MusculoskeletalAdapter extends BaseSubsectionAdapter<DischargeFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<DischargeFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Musculoskeletal assessment fields
    const musculoskeletalAssessment = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_MUSCULOSKELETAL_ASSESSMENT
    )

    const systemSummary = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_SYSTEM_SUMMARY
    )?.at(0)

    return {
      [DischargeFormField.MUSCULOSKELETAL_ASSESSMENT]: musculoskeletalAssessment,
      [DischargeFormField.MUSCULOSKELETAL_SYSTEM_SUMMARY]: systemSummary
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(DischargeFormField.MUSCULOSKELETAL_ASSESSMENT)) {
      mutations.push({
        linkId:
          DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_MUSCULOSKELETAL_ASSESSMENT,
        value: this.getFormDataField(DischargeFormField.MUSCULOSKELETAL_ASSESSMENT)
      })
    }
    if (this.formDataFieldExists(DischargeFormField.MUSCULOSKELETAL_SYSTEM_SUMMARY)) {
      mutations.push({
        linkId:
          DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_SYSTEM_SUMMARY,
        value: this.getFormDataField(DischargeFormField.MUSCULOSKELETAL_SYSTEM_SUMMARY)
      })
    }

    return mutations
  }
}
